import React, { createContext, useContext, useState, useEffect } from 'react';
import loadingService from '../services/loadingService';

const LoadingContext = createContext({
  isLoading: false,
});

export const LoadingProvider = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    // Nasłuchuj na zmiany z serwisu i aktualizuj stan Reacta
    const unsubscribe = loadingService.onChange((status) => {
      setIsLoading(status);
    });

    // Posprzątaj subskrypcję po odmontowaniu komponentu
    return () => {
      unsubscribe();
    };
  }, []); // Pusta tablica, uruchom tylko raz

  return (
    <LoadingContext.Provider value={{ isLoading }}>
      {children}
    </LoadingContext.Provider>
  );
};

// Hook ułatwiający dostęp do stanu
export const useLoading = () => useContext(LoadingContext);